var items = {
  "block.minecraft.air": "օդ",
  "block.minecraft.stone": "քար",
  "block.minecraft.granite": "գրանիտ",
  "block.minecraft.polished_granite": "հղկված գրանիտ",
  "block.minecraft.diorite": "դիորիտ",
  "block.minecraft.polished_diorite": "հղկված դիորիտ",
  "block.minecraft.andesite": "անդեզիտ",
  "block.minecraft.polished_andesite": "հղկված անդեզիտ",
  "block.minecraft.grass_block": "ճիմ",
  "block.minecraft.dirt": "կեղտ",
  "block.minecraft.coarse_dirt": "քարքարոտ հող",
  "block.minecraft.podzol": "մոխրահող",
  "block.minecraft.crimson_nylium": "ալ կարմիր նիլիում",
  "block.minecraft.warped_nylium": "աղավաղած նիլիում",
  "block.minecraft.cobblestone": "սալաքար",
  "block.minecraft.oak_planks": "կաղնու տախտակներ",
  "block.minecraft.spruce_planks": "եղևնու տախտակներ",
  "block.minecraft.birch_planks": "կեչու տախտակներ",
  "block.minecraft.jungle_planks": "արևադարձային ծառի տախտակներ",
  "block.minecraft.acacia_planks": "ակացիայի տախտակներ",
  "block.minecraft.dark_oak_planks": "մուգ կաղնու տախտակներ",
  "block.minecraft.crimson_planks": "բոսորային տախտակներ",
  "block.minecraft.warped_planks": "աղավաղված տախտակներ",
  "block.minecraft.oak_sapling": "կաղնու տնկի",
  "block.minecraft.spruce_sapling": "եղևնու տնկի",
  "block.minecraft.birch_sapling": "կեչու տնկի",
  "block.minecraft.jungle_sapling": "արևադարձային ծառի տնկի",
  "block.minecraft.acacia_sapling": "ակացիայի տնկի",
  "block.minecraft.dark_oak_sapling": "մուգ կաղնու տնկի",
  "block.minecraft.bedrock": "բեդրոկ",
  "block.minecraft.sand": "ավազ",
  "block.minecraft.red_sand": "կարմիր ավազ",
  "block.minecraft.gravel": "մանրախիճ",
  "block.minecraft.gold_ore": "ոսկու հանքաքար",
  "block.minecraft.iron_ore": "երկաթի հանքաքար",
  "block.minecraft.coal_ore": "ածուխի հանքաքար",
  "block.minecraft.nether_gold_ore": "նեզերի ոսկու հանք",
  "block.minecraft.oak_log": "կաղնու գերան",
  "block.minecraft.spruce_log": "եղևնու գերան",
  "block.minecraft.birch_log": "կեչու գերան",
  "block.minecraft.jungle_log": "արևադարձային ծառի գերան",
  "block.minecraft.acacia_log": "ակացիայի գերան",
  "block.minecraft.dark_oak_log": "մուգ կաղնու գերան",
  "block.minecraft.crimson_stem": "ալ կարմիր ծառի գերան",
  "block.minecraft.warped_stem": "աղավաղված գերան",
  "block.minecraft.stripped_oak_log": "կլպած կաղնու գերան",
  "block.minecraft.stripped_spruce_log": "կլպած եղևնու գերան",
  "block.minecraft.stripped_birch_log": "կլպած կեչու գերան",
  "block.minecraft.stripped_jungle_log": "կլպած արևադարձային ծառի գերան",
  "block.minecraft.stripped_acacia_log": "կլպած ակացիայի գերան",
  "block.minecraft.stripped_dark_oak_log": "կլպած մուգ կաղնու գերան",
  "block.minecraft.stripped_crimson_stem": "կեղևազրկած ալ կարմիր ծառի գերան",
  "block.minecraft.stripped_warped_stem": "կեղևազրկած աղավաղված գերան",
  "block.minecraft.stripped_oak_wood": "կլպած կաղնու փայտ",
  "block.minecraft.stripped_spruce_wood": "կլպած եղևնու փայտ",
  "block.minecraft.stripped_birch_wood": "կլպած կեչու փայտ",
  "block.minecraft.stripped_jungle_wood": "կլպած արևադարձային ծառի փայտ",
  "block.minecraft.stripped_acacia_wood": "կլպած ակացիայի փայտ",
  "block.minecraft.stripped_dark_oak_wood": "կլպած մուգ կաղնու փայտ",
  "block.minecraft.stripped_crimson_hyphae": "կեղևազրկած ալ կարմիր հիֆեր",
  "block.minecraft.stripped_warped_hyphae": "կեղևազրկած աղավաղված հիֆեր",
  "block.minecraft.oak_wood": "կաղնու փայտ",
  "block.minecraft.spruce_wood": "եղևնու փայտ",
  "block.minecraft.birch_wood": "կեչու փայտ",
  "block.minecraft.jungle_wood": "արևադարձային ծառի փայտ",
  "block.minecraft.acacia_wood": "ակացիաի փայտ",
  "block.minecraft.dark_oak_wood": "մուգ կաղնու փայտ",
  "block.minecraft.crimson_hyphae": "ալ կարմիր հիֆեր",
  "block.minecraft.warped_hyphae": "աղավաղված հիֆեր",
  "block.minecraft.oak_leaves": "կաղնու տերեւներ",
  "block.minecraft.spruce_leaves": "եղևնու տերեւներ",
  "block.minecraft.birch_leaves": "կեչու տերեւներ",
  "block.minecraft.jungle_leaves": "արևադարձային ծառի տերեւներ",
  "block.minecraft.acacia_leaves": "ակացիայի տերեւներ",
  "block.minecraft.dark_oak_leaves": "մուգ կաղնու տերեւներ",
  "block.minecraft.sponge": "սպունգ",
  "block.minecraft.wet_sponge": "թաց սպունգ",
  "block.minecraft.glass": "ապակի",
  "block.minecraft.lapis_ore": "լաջվարդի հանքաքար",
  "block.minecraft.lapis_block": "լաջվարդի բլոկ",
  "block.minecraft.dispenser": "բաշխիչ",
  "block.minecraft.sandstone": "ավազաքար",
  "block.minecraft.chiseled_sandstone": "փորագրված ավազաքար",
  "block.minecraft.cut_sandstone": "հարթ ավազաքար",
  "block.minecraft.note_block": "մեղեդու բլոկ",
  "block.minecraft.powered_rail": "էներգակիր ռելս",
  "block.minecraft.detector_rail": "հայտնաբերող ռելս",
  "block.minecraft.sticky_piston": "կպչուն մխոց",
  "block.minecraft.cobweb": "սարդոստայն",
  "block.minecraft.grass": "խոտ",
  "block.minecraft.fern": "պտեր",
  "block.minecraft.dead_bush": "մեռյալ թուփ",
  "block.minecraft.seagrass": "ծովախոտ",
  "block.minecraft.sea_pickle": "ծովային վարունգ",
  "block.minecraft.piston": "մխոց",
  "block.minecraft.white_wool": "սպիտակ բուրդ",
  "block.minecraft.orange_wool": "նարնջագույն բուրդ",
  "block.minecraft.magenta_wool": "մորեգույն բուրդ",
  "block.minecraft.light_blue_wool": "բաց կապույտ բուրդ",
  "block.minecraft.yellow_wool": "դեղին բուրդ",
  "block.minecraft.lime_wool": "լայմ բուրդ",
  "block.minecraft.pink_wool": "վարդագույն բուրդ",
  "block.minecraft.gray_wool": "մոխրագույն բուրդ",
  "block.minecraft.light_gray_wool": "բաց մոխրագույն բուրդ",
  "block.minecraft.cyan_wool": "փիրուզագույն բուրդ",
  "block.minecraft.purple_wool": "մանուշակագույն բուրդ",
  "block.minecraft.blue_wool": "կապույտ բուրդ",
  "block.minecraft.brown_wool": "դարչնագույն բուրդ",
  "block.minecraft.green_wool": "կանաչ բուրդ",
  "block.minecraft.red_wool": "կարմիր բուրդ",
  "block.minecraft.black_wool": "սև բուրդ",
  "block.minecraft.dandelion": "խատուտիկ",
  "block.minecraft.poppy": "կակաչ",
  "block.minecraft.blue_orchid": "կապույտ օրխիդեա",
  "block.minecraft.allium": "սոխ",
  "block.minecraft.azure_bluet": "կապույտ տերեփուկ",
  "block.minecraft.red_tulip": "կարմիր վարդակակաչ",
  "block.minecraft.orange_tulip": "նարնջագույն վարդակակաչ",
  "block.minecraft.white_tulip": "սպիտակ վարդակակաչ",
  "block.minecraft.pink_tulip": "վարդագույն վարդակակաչ",
  "block.minecraft.oxeye_daisy": "մարգարտածաղիկ",
  "block.minecraft.cornflower": "տերեփուկ",
  "block.minecraft.lily_of_the_valley": "հովտաշուշան",
  "block.minecraft.wither_rose": "թառամած վարդ",
  "block.minecraft.brown_mushroom": "շագանակագույն ճանճասպան",
  "block.minecraft.red_mushroom": "կարմիր սունկ",
  "block.minecraft.crimson_fungus": "բոսորագույն սունկ",
  "block.minecraft.warped_fungus": "աղավաղված սունկ",
  "block.minecraft.crimson_roots": "բոսորագույն արմատներ",
  "block.minecraft.warped_roots": "աղավաղված արմատներ",
  "block.minecraft.nether_sprouts": "նեզերի ծիլեր",
  "block.minecraft.weeping_vines": "լացող որթատունկ",
  "block.minecraft.twisting_vines": "գալարաձև որթատունկ",
  "block.minecraft.sugar_cane": "եղեգնաշաքար",
  "block.minecraft.kelp": "լամինարիա",
  "block.minecraft.bamboo": "հնդկեղեգ",
  "block.minecraft.gold_block": "ոսկուց բլոկ",
  "block.minecraft.iron_block": "երկաթի բլոկ",
  "block.minecraft.oak_slab": "կաղնու սալիկ",
  "block.minecraft.spruce_slab": "եղևնու սալիկ",
  "block.minecraft.birch_slab": "կեչու սալիկ",
  "block.minecraft.jungle_slab": "արևադարձային ծառի սալիկ",
  "block.minecraft.acacia_slab": "ակացիայի սալիկ",
  "block.minecraft.dark_oak_slab": "մուգ կաղնու սալիկ",
  "block.minecraft.crimson_slab": "բոսորային ծառի սալիկ",
  "block.minecraft.warped_slab": "աղավաղված սալիկ",
  "block.minecraft.stone_slab": "քարե սալիկ",
  "block.minecraft.smooth_stone_slab": "հարթ քարե սալիկ",
  "block.minecraft.sandstone_slab": "ավազաքարե սալիկ",
  "block.minecraft.cut_sandstone_slab": "հարթ ավազաքարե սալիկ",
  "block.minecraft.petrified_oak_slab": "քարացրած կաղնու սալիկ",
  "block.minecraft.cobblestone_slab": "սալաքարե սալիկ",
  "block.minecraft.brick_slab": "աղյուսի սալիկ",
  "block.minecraft.stone_brick_slab": "քարե աղյուսի սալիկ",
  "block.minecraft.nether_brick_slab": "նեզերի աղյուսից սալիկ",
  "block.minecraft.quartz_slab": "կվարցե սալիկ",
  "block.minecraft.red_sandstone_slab": "կարմիր ավազաքարե սալիկ",
  "block.minecraft.cut_red_sandstone_slab": "հարթ կարմիր ավազաքարե սալիկ",
  "block.minecraft.purpur_slab": "պուրպուրե սալիկ",
  "block.minecraft.prismarine_slab": "պրիզմարինե սալիկ",
  "block.minecraft.prismarine_brick_slab": "պրիզմարինե աղյուսի սալիկ",
  "block.minecraft.dark_prismarine_slab": "մուգ պրիզմարինե սալիկ",
  "block.minecraft.smooth_quartz": "հարթ կվարցի բլոկ",
  "block.minecraft.smooth_red_sandstone": "հարթ կարմիր ավազաքար",
  "block.minecraft.smooth_sandstone": "հարթ ավազաքար",
  "block.minecraft.smooth_stone": "հարթ քար",
  "block.minecraft.bricks": "աղյուսներ",
  "block.minecraft.tnt": "պայթուցիկ",
  "block.minecraft.bookshelf": "գրադարակ",
  "block.minecraft.mossy_cobblestone": "մամռոտած սալաքար",
  "block.minecraft.obsidian": "օբսիդիան",
  "block.minecraft.torch": "ջահ",
  "block.minecraft.end_rod": "էնդի ձող",
  "block.minecraft.chorus_plant": "քորուզի բույս",
  "block.minecraft.chorus_flower": "քորուզի ծաղիկ",
  "block.minecraft.purpur_block": "պուրպուրե բլոկ",
  "block.minecraft.purpur_pillar": "սյունաձև պուրպուրե բլոկ",
  "block.minecraft.purpur_stairs": "պուրպուրե աստիճաներ",
  "block.minecraft.spawner": "ծնիչ",
  "block.minecraft.oak_stairs": "կաղնու աստիճաններ",
  "block.minecraft.chest": "գանձարկղ",
  "block.minecraft.diamond_ore": "ադամանդի հանքաքար",
  "block.minecraft.diamond_block": "ադամանդի բլոկ",
  "block.minecraft.crafting_table": "արհեստասեղան",
  "block.minecraft.farmland": "մշակահող",
  "block.minecraft.furnace": "վառարան",
  "block.minecraft.ladder": "սանդուղք",
  "block.minecraft.rail": "ռելս",
  "block.minecraft.cobblestone_stairs": "սալաքարե աստիճաններ",
  "block.minecraft.lever": "լծակ",
  "block.minecraft.stone_pressure_plate": "քարե ճնշաթիթեղ",
  "block.minecraft.oak_pressure_plate": "կաղնու փայտից ճնշաթիթեղ",
  "block.minecraft.spruce_pressure_plate": "եղևնու փայտից ճնշաթիթեղ",
  "block.minecraft.birch_pressure_plate": "կեչու փայտից ճնշաթիթեղ",
  "block.minecraft.jungle_pressure_plate": "արևադարձային ծառի փայտից ճնշաթիթեղ",
  "block.minecraft.acacia_pressure_plate": "ակացիայի փայտից ճնշաթիթեղ",
  "block.minecraft.dark_oak_pressure_plate": "մուգ կաղնու փայտից ճնշաթիթեղ",
  "block.minecraft.crimson_pressure_plate": "բոսորային ճնշաթիթեղ",
  "block.minecraft.warped_pressure_plate": "աղավաղված ճնշաթիթեղ",
  "block.minecraft.polished_blackstone_pressure_plate": "հարթեցված սևքարե ճնշաթիթեղ",
  "block.minecraft.redstone_ore": "ռեդստունե հանքաքար",
  "block.minecraft.redstone_torch": "ռեդստունե ջահ",
  "block.minecraft.snow": "ձյուն",
  "block.minecraft.ice": "սառույց",
  "block.minecraft.snow_block": "ձյան բլոկ",
  "block.minecraft.cactus": "կակտուս",
  "block.minecraft.clay": "կավ",
  "block.minecraft.jukebox": "նվագարկիչ",
  "block.minecraft.oak_fence": "կաղնու ցանկապատ",
  "block.minecraft.spruce_fence": "եղևնու ցանկապատ",
  "block.minecraft.birch_fence": "կեչու ցանկապատ",
  "block.minecraft.jungle_fence": "արևադարձային ծառի ցանկապատ",
  "block.minecraft.acacia_fence": "ակացիայի ծառի ցանկապատ",
  "block.minecraft.dark_oak_fence": "մուգ կաղնու ցանկապատ",
  "block.minecraft.crimson_fence": "բոսորային ցանկապատ",
  "block.minecraft.warped_fence": "աղավաղված ցանկապատ",
  "block.minecraft.pumpkin": "դդում",
  "block.minecraft.carved_pumpkin": "փորագրված դդում",
  "block.minecraft.netherrack": "նեզերաքար",
  "block.minecraft.soul_sand": "հոգիների ավազ",
  "block.minecraft.soul_soil": "հոգու հող",
  "block.minecraft.basalt": "բազալտ",
  "block.minecraft.polished_basalt": "հղկված բազալտ",
  "block.minecraft.soul_torch": "հոգու ջահ",
  "block.minecraft.glowstone": "լուսարձակող քար",
  "block.minecraft.jack_o_lantern": "ջեկի լամպը",
  "block.minecraft.oak_trapdoor": "կաղնու փայտից ծուղակե դռնակ",
  "block.minecraft.spruce_trapdoor": "եղևնու փայտից ծուղակե դռնակ",
  "block.minecraft.birch_trapdoor": "կեչու փայտից ծուղակե դռնակ",
  "block.minecraft.jungle_trapdoor": "արևադարձային ծառի փայտից ծուղակե դռնակ",
  "block.minecraft.acacia_trapdoor": "ակացիայի փայտից ծուղակե դռնակ",
  "block.minecraft.dark_oak_trapdoor": "մուգ կաղնու փայտից ծուղակե դռնակ",
  "block.minecraft.crimson_trapdoor": "բոսորային ծուղակե դռնակ",
  "block.minecraft.warped_trapdoor": "աղավաղված ծուղակի դռնակ",
  "block.minecraft.infested_stone": "վարակված քար",
  "block.minecraft.infested_cobblestone": "վարակված սալաքար",
  "block.minecraft.infested_stone_bricks": "վարակված քարաղյուս",
  "block.minecraft.infested_mossy_stone_bricks": "վարակված մամռակալած քարաղյուս",
  "block.minecraft.infested_cracked_stone_bricks": "վարակված ճաքած քարաղյուս",
  "block.minecraft.infested_chiseled_stone_bricks": "վարակված փորագրված քարաղյուս",
  "block.minecraft.stone_bricks": "քարաղյուս",
  "block.minecraft.mossy_stone_bricks": "մամռոտ քարաղյուս",
  "block.minecraft.cracked_stone_bricks": "ճաքած քարաղյուս",
  "block.minecraft.chiseled_stone_bricks": "փորագրված քարաղյուս",
  "block.minecraft.brown_mushroom_block": "դարչնագույն սնկի բլոկ",
  "block.minecraft.red_mushroom_block": "կարմիր ճանճասպանի բլոկ",
  "block.minecraft.mushroom_stem": "սնկի ցողուն",
  "block.minecraft.iron_bars": "երկաթե ճաղեր",
  "block.minecraft.chain": "շղթա",
  "block.minecraft.glass_pane": "ապակու շերտ",
  "block.minecraft.melon": "սեխ",
  "block.minecraft.vine": "որթատունկ",
  "block.minecraft.oak_fence_gate": "կաղնու դարպաս",
  "block.minecraft.spruce_fence_gate": "եղևնու փայտից ցանկապատի դարպաս",
  "block.minecraft.birch_fence_gate": "կեչու փայտից ցանկապատի դարպաս",
  "block.minecraft.jungle_fence_gate": "արևադարձային ծառի փայտից ցանկապատի դարպաս",
  "block.minecraft.acacia_fence_gate": "ակացիայի փայտից ցանկապատի դարպաս",
  "block.minecraft.dark_oak_fence_gate": "մուգ կաղնու փայտից ցանկապատի դարպաս",
  "block.minecraft.crimson_fence_gate": "բոսորային  ցանկապատի դարպաս",
  "block.minecraft.warped_fence_gate": "աղավաղված ցանկապատի դարպաս",
  "block.minecraft.brick_stairs": "աղյուսե աստիճաններ",
  "block.minecraft.stone_brick_stairs": "աղյուսաքարե աստիճաններ",
  "block.minecraft.mycelium": "բորբոսահող",
  "block.minecraft.lily_pad": "ջրաշուշան",
  "block.minecraft.nether_bricks": "նեզերի աղյուսներ",
  "block.minecraft.cracked_nether_bricks": "դժոխքե ճաքած աղյուսներ",
  "block.minecraft.chiseled_nether_bricks": "փորագրված դժոխքի աղյուսներ",
  "block.minecraft.nether_brick_fence": "նեզերի աղուսից ցանկապատ",
  "block.minecraft.nether_brick_stairs": "նեզերի աղուսից աստիճաններ",
  "block.minecraft.enchanting_table": "կախարդական սեղան",
  "block.minecraft.end_portal_frame": "էնդ պորտալի շրջանակ",
  "block.minecraft.end_stone": "վերջնաքար",
  "block.minecraft.end_stone_bricks": "վերջնաքարի աղյուսներ",
  "block.minecraft.dragon_egg": "վիշապի ձու",
  "block.minecraft.redstone_lamp": "ռեդստունե լամպ",
  "block.minecraft.sandstone_stairs": "ավազաքարե աստիճաններ",
  "block.minecraft.emerald_ore": "զմրուխտի հանքաքար",
  "block.minecraft.ender_chest": "էնդերի գանձարկղ",
  "block.minecraft.tripwire_hook": "կեռիկ",
  "block.minecraft.emerald_block": "զմրուխտի բլոկ",
  "block.minecraft.spruce_stairs": "եղևնու աստիճաններ",
  "block.minecraft.birch_stairs": "կեչու աստիճաններ",
  "block.minecraft.jungle_stairs": "արևադարձային ծառի աստիճաններ",
  "block.minecraft.crimson_stairs": "բոսորային ծառից աստիճաններ",
  "block.minecraft.warped_stairs": "աղավաղված աստիճաններ",
  "block.minecraft.command_block": "հրամանների բլոկ",
  "block.minecraft.beacon": "փարոս",
  "block.minecraft.cobblestone_wall": "սալաքարե պատ",
  "block.minecraft.mossy_cobblestone_wall": "մամռոտ սալաքարե պատ",
  "block.minecraft.brick_wall": "աղյուսե պատ",
  "block.minecraft.prismarine_wall": "պրիզմարինե պատ",
  "block.minecraft.red_sandstone_wall": "կարմիր ավազաքարի պատ",
  "block.minecraft.mossy_stone_brick_wall": "մամռակալած քարաղյուսե պատ",
  "block.minecraft.granite_wall": "գրանիտե պատ",
  "block.minecraft.stone_brick_wall": "քարաղյուսե պատ",
  "block.minecraft.nether_brick_wall": "նեզերի աղյուսից պատ",
  "block.minecraft.andesite_wall": "անդեզիտե պատ",
  "block.minecraft.red_nether_brick_wall": "կարմիր նեզերի աղյուսից պատ",
  "block.minecraft.sandstone_wall": "ավազաքարի պատ",
  "block.minecraft.end_stone_brick_wall": "վերջնաքարի աղյուսե պատ",
  "block.minecraft.diorite_wall": "դիորիտե պատ",
  "block.minecraft.blackstone_wall": "սևքարե պատ",
  "block.minecraft.polished_blackstone_wall": "հարթեցված սևքարե պատ",
  "block.minecraft.polished_blackstone_brick_wall": "հարթեցված սևքարե աղյուսե պատ",
  "block.minecraft.stone_button": "քարե կոճակ",
  "block.minecraft.oak_button": "կաղնու փայտից կոճակ",
  "block.minecraft.spruce_button": "եղևնու փայտից կոճակ",
  "block.minecraft.birch_button": "կեչու փայտից կոճակ",
  "block.minecraft.jungle_button": "արևադարձային ծառի փայտից կոճակ",
  "block.minecraft.acacia_button": "ակացիայի փայտից կոճակ",
  "block.minecraft.dark_oak_button": "մուգ կաղնու փայտից կոճակ",
  "block.minecraft.crimson_button": "բոսորային կոճակ",
  "block.minecraft.warped_button": "աղավաղված կոճակ",
  "block.minecraft.polished_blackstone_button": "հարթեցված սևքարե կոճակ",
  "block.minecraft.anvil": "զնդան",
  "block.minecraft.chipped_anvil": "վնասված զնդան",
  "block.minecraft.damaged_anvil": "կոտրված զնդան",
  "block.minecraft.trapped_chest": "թակարդված գանձարկղ",
  "block.minecraft.light_weighted_pressure_plate": "թեթև կշռված ճնշաթիթեղ",
  "block.minecraft.heavy_weighted_pressure_plate": "ծանր կշռված ճնշաթիթեղ",
  "block.minecraft.daylight_detector": "ցերեկային լույսի ցուցիչ",
  "block.minecraft.redstone_block": "կարմրաքարի բլոկ",
  "block.minecraft.nether_quartz_ore": "կվարցի հանքաքար",
  "block.minecraft.hopper": "ձագար",
  "block.minecraft.chiseled_quartz_block": "փորագրված կվարցի բլոկ",
  "block.minecraft.quartz_block": "կվարցի բլոկ",
  "block.minecraft.quartz_bricks": "կվարցե աղյուսներ",
  "block.minecraft.quartz_pillar": "կվարցե սյուն",
  "block.minecraft.quartz_stairs": "կվարցե աստիճաններ",
  "block.minecraft.activator_rail": "ակտիվացնող ռելս",
  "block.minecraft.dropper": "բաշխիչ",
  "block.minecraft.white_terracotta": "սպիտակ տեռակոտա",
  "block.minecraft.orange_terracotta": "նարնջագույն տեռակոտա",
  "block.minecraft.magenta_terracotta": "մորեգույն տեռակոտա",
  "block.minecraft.light_blue_terracotta": "բաց կապույտ տեռակոտա",
  "block.minecraft.yellow_terracotta": "դեղին տեռակոտա",
  "block.minecraft.lime_terracotta": "բաց կանաչ տեռակոտա",
  "block.minecraft.pink_terracotta": "վարդագույն տեռակոտա",
  "block.minecraft.gray_terracotta": "մոխրագույն տեռակոտա",
  "block.minecraft.light_gray_terracotta": "բաց մոխրագույն տեռակոտա",
  "block.minecraft.cyan_terracotta": "փիրուզագույն տեռակոտա",
  "block.minecraft.purple_terracotta": "մանուշակագույն տեռակոտա",
  "block.minecraft.blue_terracotta": "կապույտ տեռակոտա",
  "block.minecraft.brown_terracotta": "շագանակագույն տեռակոտա",
  "block.minecraft.green_terracotta": "կանաչ տեռակոտա",
  "block.minecraft.red_terracotta": "կարմիր տեռակոտա",
  "block.minecraft.black_terracotta": "սև տեռակոտա",
  "block.minecraft.barrier": "խոչընդոտ",
  "block.minecraft.iron_trapdoor": "երկաթե դռնակ",
  "block.minecraft.hay_block": "ցորենի խուրց",
  "block.minecraft.white_carpet": "սպիտակ գորգ",
  "block.minecraft.orange_carpet": "նարնջագույն գորգ",
  "block.minecraft.magenta_carpet": "մորեգույն գորգ",
  "block.minecraft.light_blue_carpet": "բաց կապույտ գորգ",
  "block.minecraft.yellow_carpet": "դեղին գորգ",
  "block.minecraft.lime_carpet": "լայմ գորգ",
  "block.minecraft.pink_carpet": "վարդագույն գորգ",
  "block.minecraft.gray_carpet": "մոխրագույն գորգ",
  "block.minecraft.light_gray_carpet": "բաց մոխրագույն գորգ",
  "block.minecraft.cyan_carpet": "փիրուզագույն գորգ",
  "block.minecraft.purple_carpet": "մանուշակագույն գորգ",
  "block.minecraft.blue_carpet": "կապույտ գորգ",
  "block.minecraft.brown_carpet": "դարչնագույն գորգ",
  "block.minecraft.green_carpet": "կանաչ գորգ",
  "block.minecraft.red_carpet": "կարմիր գորգ",
  "block.minecraft.black_carpet": "սև գորգ",
  "block.minecraft.terracotta": "տեռակոտա",
  "block.minecraft.coal_block": "ածուխի բլոկ",
  "block.minecraft.packed_ice": "խիտ սառույց",
  "block.minecraft.acacia_stairs": "ակացիայի աստիճաններ",
  "block.minecraft.dark_oak_stairs": "մուգ կաղնու աստիճաններ",
  "block.minecraft.slime_block": "լորձի բլոկ",
  "block.minecraft.grass_path": "արահետ",
  "block.minecraft.sunflower": "արեւածաղիկ",
  "block.minecraft.lilac": "յասաման",
  "block.minecraft.rose_bush": "վարդի թուփ",
  "block.minecraft.peony": "պիոն",
  "block.minecraft.tall_grass": "բարձրահասակ խոտ",
  "block.minecraft.large_fern": "մեծ պտեր",
  "block.minecraft.white_stained_glass": "սպիտակ ապակի",
  "block.minecraft.orange_stained_glass": "նարնջագույն ապակի",
  "block.minecraft.magenta_stained_glass": "մորեգույն ապակի",
  "block.minecraft.light_blue_stained_glass": "բաց կապույտ ապակի",
  "block.minecraft.yellow_stained_glass": "դեղին ապակի",
  "block.minecraft.lime_stained_glass": "լայմ ապակի",
  "block.minecraft.pink_stained_glass": "վարդագույն ապակի",
  "block.minecraft.gray_stained_glass": "մոխրագույն ապակի",
  "block.minecraft.light_gray_stained_glass": "բաց մոխրագույն ապակի",
  "block.minecraft.cyan_stained_glass": "փիրուզագույն ապակի",
  "block.minecraft.purple_stained_glass": "մանուշակագույն ապակի",
  "block.minecraft.blue_stained_glass": "կապույտ ապակի",
  "block.minecraft.brown_stained_glass": "դարչնագույն ապակի",
  "block.minecraft.green_stained_glass": "կանաչ ապակի",
  "block.minecraft.red_stained_glass": "կարմիր ապակի",
  "block.minecraft.black_stained_glass": "սև ապակի",
  "block.minecraft.white_stained_glass_pane": "սպիտակ ապակու շերտ",
  "block.minecraft.orange_stained_glass_pane": "նարնջագույն ապակու շերտ",
  "block.minecraft.magenta_stained_glass_pane": "մորեգույն ապակու շերտ",
  "block.minecraft.light_blue_stained_glass_pane": "բաց կապույտ ապակու շերտ",
  "block.minecraft.yellow_stained_glass_pane": "դեղին ապակու շերտ",
  "block.minecraft.lime_stained_glass_pane": "լայմ ապակու շերտ",
  "block.minecraft.pink_stained_glass_pane": "վարդագույն ապակու շերտ",
  "block.minecraft.gray_stained_glass_pane": "մոխրագույն ապակու շերտ",
  "block.minecraft.light_gray_stained_glass_pane": "բաց մոխրագույն ապակու շերտ",
  "block.minecraft.cyan_stained_glass_pane": "փիրուզագույն ապակու շերտ",
  "block.minecraft.purple_stained_glass_pane": "մանուշակագույն ապակու շերտ",
  "block.minecraft.blue_stained_glass_pane": "կապույտ ապակու շերտ",
  "block.minecraft.brown_stained_glass_pane": "դարչնագույն ապակու շերտ",
  "block.minecraft.green_stained_glass_pane": "կանաչ ապակու շերտ",
  "block.minecraft.red_stained_glass_pane": "կարմիր ապակու շերտ",
  "block.minecraft.black_stained_glass_pane": "սև ապակու շերտ",
  "block.minecraft.prismarine": "պրիզմարին",
  "block.minecraft.prismarine_bricks": "պրիզմարինե աղյուս",
  "block.minecraft.dark_prismarine": "մուգ պրիզմարին",
  "block.minecraft.prismarine_stairs": "պրիզմարինե աստիճաններ",
  "block.minecraft.prismarine_brick_stairs": "պրիզմարինե աղյուսի աստիճաններ",
  "block.minecraft.dark_prismarine_stairs": "մուգ պրիզմարինե աստիճաններ",
  "block.minecraft.sea_lantern": "ջրային լապտեր",
  "block.minecraft.red_sandstone": "կարմիր ավազաքար",
  "block.minecraft.chiseled_red_sandstone": "փորագրված կարմիր ավազաքար",
  "block.minecraft.cut_red_sandstone": "հարթ կարմիր ավազաքար",
  "block.minecraft.red_sandstone_stairs": "կարմիր ավազաքարե աստիճաններ",
  "block.minecraft.repeating_command_block": "կրկնվող հրամանների բլոկ",
  "block.minecraft.chain_command_block": "շղթայած հրամանների բլոկ",
  "block.minecraft.magma_block": "մագմայի բլոկ",
  "block.minecraft.nether_wart_block": "նեզերի աճվածքի բլոկ",
  "block.minecraft.warped_wart_block": "աղավաղված աճվածքի բլոկ",
  "block.minecraft.red_nether_bricks": "կարմիր նեզերի աղյուսներ",
  "block.minecraft.bone_block": "ոսկրային բլոկ",
  "block.minecraft.structure_void": "դատարկ բլոկ",
  "block.minecraft.observer": "դիտորդիչ",
  "block.minecraft.shulker_box": "շալքերի տուփ",
  "block.minecraft.white_shulker_box": "սպիտակ շալքերի տուփ",
  "block.minecraft.orange_shulker_box": "նարնջագույն շալքերի տուփ",
  "block.minecraft.magenta_shulker_box": "մորեգույն շալքերի տուփ",
  "block.minecraft.light_blue_shulker_box": "բաց կապույտ շալքերի տուփ",
  "block.minecraft.yellow_shulker_box": "դեղին շալքերի տուփ",
  "block.minecraft.lime_shulker_box": "բաց կանաչ շալքերի տուփ",
  "block.minecraft.pink_shulker_box": "վարդագույն շալքերի տուփ",
  "block.minecraft.gray_shulker_box": "մոխրագույն շալքերի տուփ",
  "block.minecraft.light_gray_shulker_box": "բաց մոխրագույն շալքերի տուփ",
  "block.minecraft.cyan_shulker_box": "փիրուզագույն շալքերի տուփ",
  "block.minecraft.purple_shulker_box": "մանուշակագույն շալքերի տուփ",
  "block.minecraft.blue_shulker_box": "կապույտ շալքերի տուփ",
  "block.minecraft.brown_shulker_box": "դարչնագույն շալքերի տուփ",
  "block.minecraft.green_shulker_box": "կանաչ շալքերի տուփ",
  "block.minecraft.red_shulker_box": "կարմիր շալքերի տուփ",
  "block.minecraft.black_shulker_box": "սև շալքերի տուփ",
  "block.minecraft.white_glazed_terracotta": "սպիտակ թրծած տեռակոտա",
  "block.minecraft.orange_glazed_terracotta": "նարնջագույն թրծած տեռակոտա",
  "block.minecraft.magenta_glazed_terracotta": "մորեգույն թրծած տեռակոտա",
  "block.minecraft.light_blue_glazed_terracotta": "բաց կապույտ թրծած տեռակոտա",
  "block.minecraft.yellow_glazed_terracotta": "դեղին թրծած տեռակոտա",
  "block.minecraft.lime_glazed_terracotta": "բաց կանաչ թրծած տեռակոտա",
  "block.minecraft.pink_glazed_terracotta": "վարդագույն թրծած տեռակոտա",
  "block.minecraft.gray_glazed_terracotta": "մոխրագույն թրծած տեռակոտա",
  "block.minecraft.light_gray_glazed_terracotta": "բաց մոխրագույն թրծած տեռակոտա",
  "block.minecraft.cyan_glazed_terracotta": "փիրուզագույն թրծած տեռակոտա",
  "block.minecraft.purple_glazed_terracotta": "մանուշակագույն թրծած տեռակոտա",
  "block.minecraft.blue_glazed_terracotta": "կապույտ թրծած տեռակոտա",
  "block.minecraft.brown_glazed_terracotta": "դարչնագույն թրծած տեռակոտա",
  "block.minecraft.green_glazed_terracotta": "կանաչ թրծած տեռակոտա",
  "block.minecraft.red_glazed_terracotta": "կարմիր թրծած տեռակոտա",
  "block.minecraft.black_glazed_terracotta": "սև թռծած տեռակոտա",
  "block.minecraft.white_concrete": "սպիտակ բետոն",
  "block.minecraft.orange_concrete": "նարնջագույն բետոն",
  "block.minecraft.magenta_concrete": "մորեգույն բետոն",
  "block.minecraft.light_blue_concrete": "բաց կապույտ բետոն",
  "block.minecraft.yellow_concrete": "դեղին բետոն",
  "block.minecraft.lime_concrete": "լայմ բետոն",
  "block.minecraft.pink_concrete": "վարդագույն բետոն",
  "block.minecraft.gray_concrete": "մոխրագույն բետոն",
  "block.minecraft.light_gray_concrete": "բաց մոխրագույն բետոն",
  "block.minecraft.cyan_concrete": "փիրուզագույն բետոն",
  "block.minecraft.purple_concrete": "մանուշակագույն բետոն",
  "block.minecraft.blue_concrete": "կապույտ բետոն",
  "block.minecraft.brown_concrete": "դարչնագույն բետոն",
  "block.minecraft.green_concrete": "կանաչ բետոն",
  "block.minecraft.red_concrete": "կարմիր բետոն",
  "block.minecraft.black_concrete": "սև բետոն",
  "block.minecraft.white_concrete_powder": "սպիտակ փոշի բետոն",
  "block.minecraft.orange_concrete_powder": "նարնջագույն փոշի բետոն",
  "block.minecraft.magenta_concrete_powder": "մորեգույն փոշի բետոն",
  "block.minecraft.light_blue_concrete_powder": "բաց կապույտ փոշի բետոն",
  "block.minecraft.yellow_concrete_powder": "դեղին փոշի բետոն",
  "block.minecraft.lime_concrete_powder": "լայմ փոշի բետոն",
  "block.minecraft.pink_concrete_powder": "վարդագույն փոշի բետոն",
  "block.minecraft.gray_concrete_powder": "մոխրագույն փոշի բետոն",
  "block.minecraft.light_gray_concrete_powder": "բաց մոխրագույն փոշի բետոն",
  "block.minecraft.cyan_concrete_powder": "փիրուզագույն փոշի բետոն",
  "block.minecraft.purple_concrete_powder": "մանուշակագույն փոշի բետոն",
  "block.minecraft.blue_concrete_powder": "կապույտ փոշի բետոն",
  "block.minecraft.brown_concrete_powder": "շագանակագույն փոշի բետոն",
  "block.minecraft.green_concrete_powder": "կանաչ փոշի բետոն",
  "block.minecraft.red_concrete_powder": "կարմիր փոշի բետոն",
  "block.minecraft.black_concrete_powder": "սև փոշի բետոն",
  "block.minecraft.turtle_egg": "կրիայի ձու",
  "block.minecraft.dead_tube_coral_block": "մահացած գլանային մարջանի բլոկ",
  "block.minecraft.dead_brain_coral_block": "մահացած ուղեղային մարջանի բլոկ",
  "block.minecraft.dead_bubble_coral_block": "մահացած պղպջակային մարջանի բլոկ",
  "block.minecraft.dead_fire_coral_block": "մահացած կրակոտ մարջանի բլոկ",
  "block.minecraft.dead_horn_coral_block": "մահացած կոտոշային մարջանի բլոկ",
  "block.minecraft.tube_coral_block": "գլանային մարջանի բլոկ",
  "block.minecraft.brain_coral_block": "ուղեղային մարջանի բլոկ",
  "block.minecraft.bubble_coral_block": "պղպջակային մարջանի բլոկ",
  "block.minecraft.fire_coral_block": "կրակոտ մարջանի բլոկ",
  "block.minecraft.horn_coral_block": "կոտոշավոր մարջանի բլոկ",
  "block.minecraft.tube_coral": "խողովակային մարջան",
  "block.minecraft.brain_coral": "ուղեղային մարջան",
  "block.minecraft.bubble_coral": "պղպջակային մարջան",
  "block.minecraft.fire_coral": "կրակոտ մարջան",
  "block.minecraft.horn_coral": "կոտոշավոր մարջան",
  "block.minecraft.dead_brain_coral": "մահացած ուղեղային մարջան",
  "block.minecraft.dead_bubble_coral": "մահացած խողովակային մարջան",
  "block.minecraft.dead_fire_coral": "մահացած կրակոտ մարջան",
  "block.minecraft.dead_horn_coral": "մահացած կոտոշավոր մարջան",
  "block.minecraft.dead_tube_coral": "մահացած խողովակային մարջան",
  "block.minecraft.tube_coral_fan": "հովհարային խողովակային մարջան",
  "block.minecraft.brain_coral_fan": "հովհարային ուղեղային մարջան",
  "block.minecraft.bubble_coral_fan": "հովհարային պղպջակավոր մարջան",
  "block.minecraft.fire_coral_fan": "հովհարային կրակոտ մարջան",
  "block.minecraft.horn_coral_fan": "հովհարային կոտոշավոր մարջան",
  "block.minecraft.dead_tube_coral_fan": "մահացած հովհարային խողովակային մարջան",
  "block.minecraft.dead_brain_coral_fan": "մահացած հովհարային ուղեղային մարջան",
  "block.minecraft.dead_bubble_coral_fan": "մահացած հովհարային պղպջակային մարջան",
  "block.minecraft.dead_fire_coral_fan": "մահացած հովհարային կրակոտ մարջան",
  "block.minecraft.dead_horn_coral_fan": "մահացած հովհարային կոտոշավոր մարջան",
  "block.minecraft.blue_ice": "կապույտ սառույց",
  "block.minecraft.conduit": "ծովային սկզբնաղբյուր",
  "block.minecraft.polished_granite_stairs": "հարթեցված գրանիտե աստիճաններ",
  "block.minecraft.smooth_red_sandstone_stairs": "հարթեցված կարմիր ավազաքարե աստիճաններ",
  "block.minecraft.mossy_stone_brick_stairs": "մամռակալած քարե աղյուսե աստիճաններ",
  "block.minecraft.polished_diorite_stairs": "հարթեցված դիորիտե աստիճաններ",
  "block.minecraft.mossy_cobblestone_stairs": "մամռակալած սալաքարե աստիճաններ",
  "block.minecraft.end_stone_brick_stairs": "վերջնաքարե աղյուսե աստիճաններ",
  "block.minecraft.stone_stairs": "քարե աստիճաններ",
  "block.minecraft.smooth_sandstone_stairs": "հարթեցված ավազաքարե աստիճաններ",
  "block.minecraft.smooth_quartz_stairs": "հարթ կվարցի աստիճաններ",
  "block.minecraft.granite_stairs": "գրանիտե աստիճաններ",
  "block.minecraft.andesite_stairs": "անդեզիտե աստիճաններ",
  "block.minecraft.red_nether_brick_stairs": "կարմիր նեզերի աղյուսից աստիճաններ",
  "block.minecraft.polished_andesite_stairs": "հղկված անդեզիտե աստիճաններ",
  "block.minecraft.diorite_stairs": "դիորիտե աստիճաններ",
  "block.minecraft.polished_granite_slab": "հարթեցված գրանիտե սալիկ",
  "block.minecraft.smooth_red_sandstone_slab": "հարթ կարմիր ավազաքարե սալիկ",
  "block.minecraft.mossy_stone_brick_slab": "մամռակալած քարաղյուսե սալիկ",
  "block.minecraft.polished_diorite_slab": "հարթեցված դիորիտե սալիկ",
  "block.minecraft.mossy_cobblestone_slab": "մամռակալած սալաքարե սալիկ",
  "block.minecraft.end_stone_brick_slab": "վերջնաքարի աղյուսե սալիկ",
  "block.minecraft.smooth_sandstone_slab": "հարթ ավազաքարե սալիկ",
  "block.minecraft.smooth_quartz_slab": "հարթ կվարցե սալիկ",
  "block.minecraft.granite_slab": "գրանիտե սալիկ",
  "block.minecraft.andesite_slab": "անդեզիտե սալիկ",
  "block.minecraft.red_nether_brick_slab": "նեզերի կարմիր աղյուսից սալիկ",
  "block.minecraft.polished_andesite_slab": "հարթեցված անդեզիտե սալիկ",
  "block.minecraft.diorite_slab": "դիորիտե սալիկ",
  "block.minecraft.scaffolding": "լաստակ",
  "block.minecraft.iron_door": "երկաթե դուռ",
  "block.minecraft.oak_door": "կաղնե դուռ",
  "block.minecraft.spruce_door": "եղևնու դուռ",
  "block.minecraft.birch_door": "կեչու դուռ",
  "block.minecraft.jungle_door": "արևադարձային ծառի դուռ",
  "block.minecraft.acacia_door": "ակացիայի դուռ",
  "block.minecraft.dark_oak_door": "մուգ կաղնե դուռ",
  "block.minecraft.crimson_door": "բոսորային դուռ",
  "block.minecraft.warped_door": "աղավաղված դուռ",
  "block.minecraft.repeater": "ռեդստունե կրկնիչ",
  "block.minecraft.comparator": "ռեդստունե համեմատիչ",
  "block.minecraft.structure_block": "կառուցվածքի բլոկ",
  "block.minecraft.jigsaw": "փազլ",
  "item.minecraft.turtle_helmet": "կրիայի պատյան□□երբ գլխին է՝□+2 զրահ",
  "item.minecraft.scute": "պատյան",
  "item.minecraft.iron_shovel": "երկաթե բահ□□հիմնական ձեռքում՝□+3.5 հարվածի ուժը□-3 հարձակման արագությունը",
  "item.minecraft.iron_pickaxe": "երկաթե քլունգ□□հիմնական ձեռքում՝□+3 հարվածի ուժը□-2.8 հարձակման արագությունը",
  "item.minecraft.iron_axe": "երկաթե կացին□□հիմնական ձեռքում՝□+8 հարվածի ուժը□-3.1 հարձակման արագությունը",
  "item.minecraft.flint_and_steel": "վառիչ",
  "item.minecraft.apple": "խնձոր",
  "item.minecraft.bow": "նետ",
  "item.minecraft.arrow": "աղեղ",
  "item.minecraft.coal": "ածուխ",
  "item.minecraft.charcoal": "փայտացուխ",
  "item.minecraft.diamond": "ադամանդ",
  "item.minecraft.iron_ingot": "երկաթե ձույլ",
  "item.minecraft.gold_ingot": "ոսկե ձույլ",
  "item.minecraft.netherite_ingot": "նեզերիտե ձուլակտոր",
  "item.minecraft.netherite_scrap": "նեզերիտի կտոր",
  "item.minecraft.iron_sword": "երկաթե թուր□□հիմնական ձեռքում՝□+5 հարվածի ուժը□-2.4 հարձակման արագությունը",
  "item.minecraft.wooden_sword": "փայտե թուր□□հիմնական ձեռքում՝□+3 հարվածի ուժը□-2.4 հարձակման արագությունը",
  "item.minecraft.wooden_shovel": "փայտե բահ□□հիմնական ձեռքում՝□+1.5 հարվածի ուժը□-3 հարձակման արագությունը",
  "item.minecraft.wooden_pickaxe": "փայտե քլունգ□□հիմնական ձեռքում՝□+1 հարվածի ուժը□-2.8 հարձակման արագությունը",
  "item.minecraft.wooden_axe": "փայտե կացին□□հիմնական ձեռքում՝□+6 հարվածի ուժը□-3.2 հարձակման արագությունը",
  "item.minecraft.stone_sword": "քարե սուր□□հիմնական ձեռքում՝□+4 հարվածի ուժը□-2.4 հարձակման արագությունը",
  "item.minecraft.stone_shovel": "քարե թիակ□□հիմնական ձեռքում՝□+2.5 հարվածի ուժը□-3 հարձակման արագությունը",
  "item.minecraft.stone_pickaxe": "քարե քլունգ□□հիմնական ձեռքում՝□+2 հարվածի ուժը□-2.8 հարձակման արագությունը",
  "item.minecraft.stone_axe": "քարե կացին□□հիմնական ձեռքում՝□+8 հարվածի ուժը□-3.2 հարձակման արագությունը",
  "item.minecraft.diamond_sword": "ադամանդե սուր□□հիմնական ձեռքում՝□+6 հարվածի ուժը□-2.4 հարձակման արագությունը",
  "item.minecraft.diamond_shovel": "ադամանդե թիակ□□հիմնական ձեռքում՝□+4.5 հարվածի ուժը□-3 հարձակման արագությունը",
  "item.minecraft.diamond_pickaxe": "ադամանդե քլունգ□□հիմնական ձեռքում՝□+4 հարվածի ուժը□-2.8 հարձակման արագությունը",
  "item.minecraft.diamond_axe": "ադամանդե կացին□□հիմնական ձեռքում՝□+8 հարվածի ուժը□-3 հարձակման արագությունը",
  "item.minecraft.stick": "փայտիկ",
  "item.minecraft.bowl": "աման",
  "item.minecraft.mushroom_stew": "շոգեխաշած սունկ",
  "item.minecraft.golden_sword": "ոսկե թուր□□հիմնական ձեռքում՝□+3 հարվածի ուժը□-2.4 հարձակման արագությունը",
  "item.minecraft.golden_shovel": "ոսկե բահ□□հիմնական ձեռքում՝□+1.5 հարվածի ուժը□-3 հարձակման արագությունը",
  "item.minecraft.golden_pickaxe": "ոսկե քլունգ□□հիմնական ձեռքում՝□+1 հարվածի ուժը□-2.8 հարձակման արագությունը",
  "item.minecraft.golden_axe": "ոսկե կացին□□հիմնական ձեռքում՝□+6 հարվածի ուժը□-3 հարձակման արագությունը",
  "item.minecraft.netherite_sword": "նեզերիտե թուր□□հիմնական ձեռքում՝□+7 հարվածի ուժը□-2.4 հարձակման արագությունը",
  "item.minecraft.netherite_shovel": "նեզերիտե բահ□□հիմնական ձեռքում՝□+5.5 հարվածի ուժը□-3 հարձակման արագությունը",
  "item.minecraft.netherite_pickaxe": "նեզերիտե քլունգ□□հիմնական ձեռքում՝□+5 հարվածի ուժը□-2.8 հարձակման արագությունը",
  "item.minecraft.netherite_axe": "նեզերիտե կացին□□հիմնական ձեռքում՝□+9 հարվածի ուժը□-3 հարձակման արագությունը",
  "item.minecraft.string": "թել",
  "item.minecraft.feather": "փետուր",
  "item.minecraft.gunpowder": "վառոդ",
  "item.minecraft.wooden_hoe": "փայտե թոխր□□հիմնական ձեռքում՝□-3 հարձակման արագությունը",
  "item.minecraft.stone_hoe": "քարե թոխր□□հիմնական ձեռքում՝□-2 հարձակման արագությունը",
  "item.minecraft.iron_hoe": "երկաթե թոխր□□հիմնական ձեռքում՝□-1 հարձակման արագությունը",
  "item.minecraft.diamond_hoe": "ադամանդե թոխր□□հիմնական ձեռքում՝",
  "item.minecraft.golden_hoe": "ոսկե թոխր□□հիմնական ձեռքում՝□-3 հարձակման արագությունը",
  "item.minecraft.netherite_hoe": "նեզերիտե թոխր□□հիմնական ձեռքում՝",
  "item.minecraft.wheat_seeds": "ցորենի սերմեր",
  "item.minecraft.wheat": "ցորեն",
  "item.minecraft.bread": "հաց",
  "item.minecraft.leather_helmet": "կաշվե սաղավարտ□□երբ գլխին է՝□+1 զրահ",
  "item.minecraft.leather_chestplate": "կաշվե կրծքապանակ□□երբ մարմնին է՝□+3 զրահ",
  "item.minecraft.leather_leggings": "կաշվե տաբատ□□երբ ոտքերին է՝□+2 զրահ",
  "item.minecraft.leather_boots": "կաշվե կոշիկներ□□երբ ոտքերին է։:□+1 զրահ",
  "item.minecraft.chainmail_helmet": "օղազրահե սաղավարտ□□երբ գլխին է՝□+2 զրահ",
  "item.minecraft.chainmail_chestplate": "օղազրահ կրծքապանակ□□երբ մարմնին է՝□+5 զրահ",
  "item.minecraft.chainmail_leggings": "օղազրահ տապաթ□□երբ ոտքերին է՝□+4 զրահ",
  "item.minecraft.chainmail_boots": "օղազրահե կոշիկներ□□երբ ոտքերին է։:□+1 զրահ",
  "item.minecraft.iron_helmet": "երկաթե սաղավարտ□□երբ գլխին է՝□+2 զրահ",
  "item.minecraft.iron_chestplate": "երկաթե կրծքապանակ□□երբ մարմնին է՝□+6 զրահ",
  "item.minecraft.iron_leggings": "երկաթե անդրավարտիկ□□երբ ոտքերին է՝□+5 զրահ",
  "item.minecraft.iron_boots": "երկաթե կոշիկներ□□երբ ոտքերին է։:□+2 զրահ",
  "item.minecraft.diamond_helmet": "ադամանդե սաղավարտ□□երբ գլխին է՝□+3 զրահ□+2 զրահի կոշտությունը",
  "item.minecraft.diamond_chestplate": "ադամանդե կրծքապանակ□□երբ մարմնին է՝□+8 զրահ□+2 զրահի կոշտությունը",
  "item.minecraft.diamond_leggings": "ադամանդե վարտիկ□□երբ ոտքերին է՝□+6 զրահ□+2 զրահի կոշտությունը",
  "item.minecraft.diamond_boots": "ադամանդե կոշիկներ□□երբ ոտքերին է։:□+3 զրահ□+2 զրահի կոշտությունը",
  "item.minecraft.golden_helmet": "ոսկե սաղավարտ□□երբ գլխին է՝□+2 զրահ",
  "item.minecraft.golden_chestplate": "ոսկե կրծքապանակ□□երբ մարմնին է՝□+5 զրահ",
  "item.minecraft.golden_leggings": "ոսկե վարտիկ□□երբ ոտքերին է՝□+3 զրահ",
  "item.minecraft.golden_boots": "ոսկե կոշիկներ□□երբ ոտքերին է։:□+1 զրահ",
  "item.minecraft.netherite_helmet": "նեզերիտե սաղավարտ□□երբ գլխին է՝□+3 զրահ□+3 զրահի կոշտությունը□+1 բռթելու դիմադրություն",
  "item.minecraft.netherite_chestplate": "նեզերիտե կրծքապանակ□□երբ մարմնին է՝□+8 զրահ□+3 զրահի կոշտությունը□+1 բռթելու դիմադրություն",
  "item.minecraft.netherite_leggings": "նեզերիտե տապաթ□□երբ ոտքերին է՝□+6 զրահ□+3 զրահի կոշտությունը□+1 բռթելու դիմադրություն",
  "item.minecraft.netherite_boots": "նեզերիտե կոշիկներ□□երբ ոտքերին է։:□+3 զրահ□+3 զրահի կոշտությունը□+1 բռթելու դիմադրություն",
  "item.minecraft.flint": "կայծքար",
  "item.minecraft.porkchop": "հում խոզի միս",
  "item.minecraft.cooked_porkchop": "խոզի խորոված",
  "item.minecraft.painting": "նկար",
  "item.minecraft.golden_apple": "ոսկե խնձորր",
  "item.minecraft.enchanted_golden_apple": "կախարդված ոսկե խնձոր",
  "block.minecraft.oak_sign": "կաղնու ցուցանակ",
  "block.minecraft.spruce_sign": "եղևնու ցուցանակ",
  "block.minecraft.birch_sign": "կեչու ցուցանակ",
  "block.minecraft.jungle_sign": "արևադարձային ծառի ցուցանակ",
  "block.minecraft.acacia_sign": "ակացիայի ցուցանակ",
  "block.minecraft.dark_oak_sign": "մուգ կաղնու ցուցանակ",
  "block.minecraft.crimson_sign": "բոսորային ցուցանակ",
  "block.minecraft.warped_sign": "աղավաղված ցուցանակ",
  "item.minecraft.bucket": "դույլ",
  "item.minecraft.water_bucket": "ջրով դույլ",
  "item.minecraft.lava_bucket": "լավայով դույլ",
  "item.minecraft.minecart": "վագոն",
  "item.minecraft.saddle": "թամբ",
  "item.minecraft.redstone": "կարմիր փոշի",
  "item.minecraft.snowball": "ձնագնդիկ",
  "item.minecraft.oak_boat": "կաղնե նավակ",
  "item.minecraft.leather": "կաշի",
  "item.minecraft.milk_bucket": "կաթով դույլ",
  "item.minecraft.pufferfish_bucket": "փքաձուկը դույլի մեջ",
  "item.minecraft.salmon_bucket": "դույլով սաղմոն",
  "item.minecraft.cod_bucket": "ձողաձկան դույլ",
  "item.minecraft.tropical_fish_bucket": "արևադարձային ձուկը դույլի մեջ",
  "item.minecraft.brick": "աղյուս",
  "item.minecraft.clay_ball": "կավե գնդիկ",
  "block.minecraft.dried_kelp_block": "չորացրած լամինարիայի բլոկ",
  "item.minecraft.paper": "թուղթ",
  "item.minecraft.book": "գիրք",
  "item.minecraft.slime_ball": "լորձագնդակ",
  "item.minecraft.chest_minecart": "վագոն սնդուկով",
  "item.minecraft.furnace_minecart": "շարժիչով վագոն",
  "item.minecraft.egg": "ձու",
  "item.minecraft.compass": "կողմնացույց",
  "item.minecraft.fishing_rod": "կարթաձող",
  "item.minecraft.clock": "ժամացույց",
  "item.minecraft.glowstone_dust": "լուսարձակող քարի փոշի",
  "item.minecraft.cod": "հում ձողաձուկ",
  "item.minecraft.salmon": "հում սաղմոն",
  "item.minecraft.tropical_fish": "արևադարձային ձուկ",
  "item.minecraft.pufferfish": "փքաձուկ",
  "item.minecraft.cooked_cod": "եփված ձողաձուկ",
  "item.minecraft.cooked_salmon": "պատրաստված սաղմոն",
  "item.minecraft.ink_sac": "թանաք",
  "item.minecraft.red_dye": "կարմիր ներկ",
  "item.minecraft.green_dye": "կանաչ ներկ",
  "item.minecraft.cocoa_beans": "կակաո-լոբի",
  "item.minecraft.lapis_lazuli": "լաջվարդե",
  "item.minecraft.purple_dye": "մանուշակագույն ներկ",
  "item.minecraft.cyan_dye": "փիրուզագույն ներկ",
  "item.minecraft.light_gray_dye": "բաց մոխրագույն ներկ",
  "item.minecraft.gray_dye": "մոխրագույն ներկ",
  "item.minecraft.pink_dye": "վարդագույն ներկ",
  "item.minecraft.lime_dye": "լայմ ներկ",
  "item.minecraft.yellow_dye": "դեղին ներկ",
  "item.minecraft.light_blue_dye": "բաց կապույտ ներկ",
  "item.minecraft.magenta_dye": "մորեգույն ներկ",
  "item.minecraft.orange_dye": "նարնջագույն ներկ",
  "item.minecraft.bone_meal": "ոսկորի փոշի",
  "item.minecraft.blue_dye": "կապույտ ներկ",
  "item.minecraft.brown_dye": "շագանակագույն ներկ",
  "item.minecraft.black_dye": "սեւ ներկ",
  "item.minecraft.white_dye": "սպիտակ ներկ",
  "item.minecraft.bone": "ոսկոր",
  "item.minecraft.sugar": "շաքար",
  "block.minecraft.cake": "թխվածք",
  "block.minecraft.white_bed": "սպիտակ մահճակալ",
  "block.minecraft.orange_bed": "նարնջագույն մահճակալ",
  "block.minecraft.magenta_bed": "բաց վարդագույն մահճակալ",
  "block.minecraft.light_blue_bed": "բաց կապույտ մահճակալ",
  "block.minecraft.yellow_bed": "դեղին մահճակալ",
  "block.minecraft.lime_bed": "լայմ մահճակալ",
  "block.minecraft.pink_bed": "վարդագույն մահճակալ",
  "block.minecraft.gray_bed": "մոխրագույն մահճակալ",
  "block.minecraft.light_gray_bed": "բաց մոխրագույն մահճակալ",
  "block.minecraft.cyan_bed": "բաց կապույտ մահճակալ",
  "block.minecraft.purple_bed": "մանուշակագույն մահճակալ",
  "block.minecraft.blue_bed": "կապույտ մահճակալ",
  "block.minecraft.brown_bed": "շագանակագույն մահճակալ",
  "block.minecraft.green_bed": "կանաչ մահճակալ",
  "block.minecraft.red_bed": "կարմիր մահճակալ",
  "block.minecraft.black_bed": "սեւ մահճակալ",
  "item.minecraft.cookie": "թխվածք",
  "item.minecraft.filled_map": "քարտեզ□#0",
  "item.minecraft.shears": "մկրատ",
  "item.minecraft.melon_slice": "ձմերուկի կտոր",
  "item.minecraft.dried_kelp": "չորացրած լամինարիյա",
  "item.minecraft.pumpkin_seeds": "դդմի սերմեր",
  "item.minecraft.melon_seeds": "ձմերուկի սերմեր",
  "item.minecraft.beef": "հում տավարի միս",
  "item.minecraft.cooked_beef": "բիֆշտեքս",
  "item.minecraft.chicken": "հում հավ",
  "item.minecraft.cooked_chicken": "հավի խորոված",
  "item.minecraft.rotten_flesh": "փտած միս",
  "item.minecraft.ender_pearl": "էնդերի մարգարիտ",
  "item.minecraft.blaze_rod": "բոցավառի ձող",
  "item.minecraft.ghast_tear": "գաստի արցունք",
  "item.minecraft.gold_nugget": "ոսկու բնակտոր",
  "item.minecraft.nether_wart": "նեզերի աճվածք",
  "item.minecraft.potion": "անսարքելի դեղ□առանց էֆեկտի",
  "item.minecraft.glass_bottle": "ապակե շիշ",
  "item.minecraft.spider_eye": "սարդի աչք",
  "item.minecraft.fermented_spider_eye": "սարդի ֆերմենտացված աչք",
  "item.minecraft.blaze_powder": "բոցավարի փոշի",
  "item.minecraft.magma_cream": "մագմայի գունդ",
  "block.minecraft.brewing_stand": "թուրմի կայանք",
  "block.minecraft.cauldron": "կաթսա",
  "item.minecraft.ender_eye": "էնդերի աչք",
  "item.minecraft.glistering_melon_slice": "շողացող ձմերուկի դիլիմ",
  "item.minecraft.bat_spawn_egg": "չղջիկ ստեղծելու ձու",
  "item.minecraft.bee_spawn_egg": "մեղու ստեղծելու ձու",
  "item.minecraft.blaze_spawn_egg": "բոցավառ ստեղծելու ձու",
  "item.minecraft.cat_spawn_egg": "կատու ծնելու ձու",
  "item.minecraft.cave_spider_spawn_egg": "քարանձավային սարդ ծնելու ձու",
  "item.minecraft.chicken_spawn_egg": "հավ ծնելու ձու",
  "item.minecraft.cod_spawn_egg": "ձողաձկան ծնելու ձու",
  "item.minecraft.cow_spawn_egg": "կով ծնելու ձու",
  "item.minecraft.creeper_spawn_egg": "քրիփեր ստեղծելու ձու",
  "item.minecraft.dolphin_spawn_egg": "դելֆին ծնելու ձու",
  "item.minecraft.donkey_spawn_egg": "ավանակ ստեղծելու ձու",
  "item.minecraft.drowned_spawn_egg": "խեղդյալ ծնելու ձու",
  "item.minecraft.elder_guardian_spawn_egg": "հնագույն պահապան ստեղծելու ձու",
  "item.minecraft.enderman_spawn_egg": "էնդերմեն ծնելու ձու",
  "item.minecraft.endermite_spawn_egg": "էնդերմիտ ծնելու ձու",
  "item.minecraft.evoker_spawn_egg": "կախարդիչ ստեղծելու ձու",
  "item.minecraft.fox_spawn_egg": "աղվես ծնելու ձու",
  "item.minecraft.ghast_spawn_egg": "գաստ ստեղծելու ձու",
  "item.minecraft.guardian_spawn_egg": "պահապան ստեղծելու ձու",
  "item.minecraft.hoglin_spawn_egg": "հոգլին ծնելու ձու",
  "item.minecraft.horse_spawn_egg": "ձի ծնելու ձու",
  "item.minecraft.husk_spawn_egg": "կադավր ստեղծելու ձու",
  "item.minecraft.llama_spawn_egg": "լամա ծնելու ձու",
  "item.minecraft.magma_cube_spawn_egg": "մագմային խորանարդ ստեղծելու ձու",
  "item.minecraft.mooshroom_spawn_egg": "անասուունկը ծնելու ձու",
  "item.minecraft.mule_spawn_egg": "մուլա ծնելու ձու",
  "item.minecraft.ocelot_spawn_egg": "օցելոտ ստեղծելու ձու",
  "item.minecraft.panda_spawn_egg": "պանդա ծնելու ձու",
  "item.minecraft.parrot_spawn_egg": "թութակ ծնելու ձու",
  "item.minecraft.phantom_spawn_egg": "ֆանտոմ ծնելու ձու",
  "item.minecraft.pig_spawn_egg": "խոզ ծնելու ձու",
  "item.minecraft.piglin_spawn_egg": "փիգլին ծնելու ձու",
  "item.minecraft.pillager_spawn_egg": "ավազակ ստեղծելու ձու",
  "item.minecraft.polar_bear_spawn_egg": "սպիտակ արջ ծնելու ձու",
  "item.minecraft.pufferfish_spawn_egg": "փքաձուկ ծնելու ձու",
  "item.minecraft.rabbit_spawn_egg": "ճագար ծնելու ձու",
  "item.minecraft.ravager_spawn_egg": "ավերիչ ծնելու ձու",
  "item.minecraft.salmon_spawn_egg": "սաղմոն ծնելու ձու",
  "item.minecraft.sheep_spawn_egg": "ոչխար ծնելու ձու",
  "item.minecraft.shulker_spawn_egg": "շալկեր ծնելու ձու",
  "item.minecraft.silverfish_spawn_egg": "արծաթաթեփուկ ստեղծելու ձու",
  "item.minecraft.skeleton_spawn_egg": "կմախք ծնելու ձու",
  "item.minecraft.skeleton_horse_spawn_egg": "կմախք-ձի ծնելու ձու",
  "item.minecraft.slime_spawn_egg": "լորձ ծնելու ձու",
  "item.minecraft.spider_spawn_egg": "սարդ ծնելու ձու",
  "item.minecraft.squid_spawn_egg": "ութոտնուկ ծնելու ձու",
  "item.minecraft.stray_spawn_egg": "թափառող ստեղծելու ձու",
  "item.minecraft.strider_spawn_egg": "լավաքայլիկ ծնելու ձու",
  "item.minecraft.trader_llama_spawn_egg": "առևտրականի լամա ծնելու ձու",
  "item.minecraft.tropical_fish_spawn_egg": "արևադարձային ձուկ ծնելու ձու",
  "item.minecraft.turtle_spawn_egg": "կրիա ծնելու ձու",
  "item.minecraft.vex_spawn_egg": "վնասող ստեղծելու ձու",
  "item.minecraft.villager_spawn_egg": "գյուղացի ստեղծելու ձու",
  "item.minecraft.vindicator_spawn_egg": "վինդիկատր ստեղծելու ձու",
  "item.minecraft.wandering_trader_spawn_egg": "թափառող առևտրական ստեղծելու ձու",
  "item.minecraft.witch_spawn_egg": "վհուկ ստեղծելու ձու",
  "item.minecraft.wither_skeleton_spawn_egg": "ոչնչացնող կմախք ստեղծելու ձու",
  "item.minecraft.wolf_spawn_egg": "գայլ ստեղծելու ձու",
  "item.minecraft.zoglin_spawn_egg": "զոմբիացված հոգլին ստեղծելու ձու",
  "item.minecraft.zombie_spawn_egg": "զոմբի ստեղծելու ձու",
  "item.minecraft.zombie_horse_spawn_egg": "զոմբիացած ձի ստեղծելու ձու",
  "item.minecraft.zombie_villager_spawn_egg": "չոմբիացված գյուղացի ստեղծելու ձու",
  "item.minecraft.zombified_piglin_spawn_egg": "զոմբիֆիկացված փիգլին ստեղծման ձու",
  "item.minecraft.experience_bottle": "փորձառությունների շիշ",
  "item.minecraft.fire_charge": "կրակի գունդ",
  "item.minecraft.writable_book": "գիրք և փետուր",
  "item.minecraft.written_book": "գրված գիրք",
  "item.minecraft.emerald": "զմրուխտ",
  "item.minecraft.item_frame": "առարկայի շրջանակ",
  "block.minecraft.flower_pot": "ծաղկաման",
  "item.minecraft.carrot": "գազար",
  "item.minecraft.potato": "կարտոֆիլ",
  "item.minecraft.baked_potato": "թխված կարտոֆիլ",
  "item.minecraft.poisonous_potato": "թունավոր կարտոֆիլ",
  "item.minecraft.map": "դատարկ քարտեզ",
  "item.minecraft.golden_carrot": "ոսկե գազար",
  "block.minecraft.skeleton_skull": "կմախքի գանգ",
  "block.minecraft.wither_skeleton_skull": "սև կմախքի գանգ",
  "block.minecraft.player_head": "խաղացողի գլուխ",
  "block.minecraft.zombie_head": "զոմբիի գլուխ",
  "block.minecraft.creeper_head": "քրիփերի գլուխ",
  "block.minecraft.dragon_head": "վիշապի գլուխ",
  "item.minecraft.carrot_on_a_stick": "գազար փայտիկի վրա",
  "item.minecraft.warped_fungus_on_a_stick": "աղավաղված սունկ փայտի վրա",
  "item.minecraft.nether_star": "նեզերի աստղ",
  "item.minecraft.pumpkin_pie": "դդմով կարկանդակ",
  "item.minecraft.firework_rocket": "հրավառություն",
  "item.minecraft.firework_star": "հրավառության աստղ",
  "item.minecraft.enchanted_book": "կախարդական գիրք",
  "item.minecraft.nether_brick": "դժոխքային աղյուս",
  "item.minecraft.quartz": "կվարց",
  "item.minecraft.tnt_minecart": "պայթուցիկով վագոն",
  "item.minecraft.hopper_minecart": "ձագարով վագոն",
  "item.minecraft.prismarine_shard": "պրիզմարինի շեղ",
  "item.minecraft.prismarine_crystals": "պրիզմարինի բյուրեղ",
  "item.minecraft.rabbit": "հում նապաստակ",
  "item.minecraft.cooked_rabbit": "պատրաստված նապաստակ",
  "item.minecraft.rabbit_stew": "շոգեխաշած նապաստակ",
  "item.minecraft.rabbit_foot": "ճագարի ոտք",
  "item.minecraft.rabbit_hide": "ճագարի մորթի",
  "item.minecraft.armor_stand": "զրահի հենարան",
  "item.minecraft.iron_horse_armor": "ձիու երկաթե զրահ",
  "item.minecraft.golden_horse_armor": "ձիու ոսկե զրահ",
  "item.minecraft.diamond_horse_armor": "ձիու ադամանդե զրահ",
  "item.minecraft.leather_horse_armor": "ձիու կաշվե զրահ",
  "item.minecraft.lead": "սանձ",
  "item.minecraft.name_tag": "անվանապիտակ",
  "item.minecraft.command_block_minecart": "վագոն հրամանի բլոկով",
  "item.minecraft.mutton": "հում ոչխարի միս",
  "item.minecraft.cooked_mutton": "ոչխարի խորոված",
  "block.minecraft.white_banner": "սպիտակ դրոշ",
  "block.minecraft.orange_banner": "նարնջագույն դրոշ",
  "block.minecraft.magenta_banner": "մորեգույն դրոշ",
  "block.minecraft.light_blue_banner": "բաց կապույտ դրոշ",
  "block.minecraft.yellow_banner": "դեղին դրոշ",
  "block.minecraft.lime_banner": "լայմ դրոշ",
  "block.minecraft.pink_banner": "վարդագույն դրոշ",
  "block.minecraft.gray_banner": "մոխրագույն դրոշ",
  "block.minecraft.light_gray_banner": "բաց մոխրագույն դրոշ",
  "block.minecraft.cyan_banner": "փիրուզագույն դրոշ",
  "block.minecraft.purple_banner": "մանուշակագույն դրոշ",
  "block.minecraft.blue_banner": "կապույտ դրոշ",
  "block.minecraft.brown_banner": "դառչագույն դրոշ",
  "block.minecraft.green_banner": "կանաչ դրոշ",
  "block.minecraft.red_banner": "կարմիր դրոշ",
  "block.minecraft.black_banner": "սև դրոշ",
  "item.minecraft.end_crystal": "էնդի բյուրեղ",
  "item.minecraft.chorus_fruit": "քորուզի պտուղ",
  "item.minecraft.popped_chorus_fruit": "տապակած քորուզի պտուղ",
  "item.minecraft.beetroot": "բողկ",
  "item.minecraft.beetroot_seeds": "բողկի սերմեր",
  "item.minecraft.beetroot_soup": "բողկի ապուր",
  "item.minecraft.dragon_breath": "վիշապի շնչառաց",
  "item.minecraft.splash_potion": "պայթուցիկ անսարքելի դեղ□առանց էֆեկտի",
  "item.minecraft.spectral_arrow": "սպեկտրալ աղեղ",
  "item.minecraft.tipped_arrow": "անսարքելի դեղով նետը□առանց էֆեկտի",
  "item.minecraft.lingering_potion": "անսարքելի երկարատեւ դեղ□առանց էֆեկտի",
  "item.minecraft.shield": "վահան",
  "item.minecraft.elytra": "էլիտրաներ",
  "item.minecraft.spruce_boat": "եղևնու ծառից նավակ",
  "item.minecraft.birch_boat": "կեչու ծառից նավակ",
  "item.minecraft.jungle_boat": "արևադարձային ծառի փայտից նավակ",
  "item.minecraft.acacia_boat": "ակացիայի փայտից նավակ",
  "item.minecraft.dark_oak_boat": "մուգ կաղնե նավակ",
  "item.minecraft.totem_of_undying": "անմահության տոտեմ",
  "item.minecraft.shulker_shell": "շալքերի խեցի",
  "item.minecraft.iron_nugget": "երկաթյա կտոր",
  "item.minecraft.knowledge_book": "գիտելիքների գիրք",
  "item.minecraft.debug_stick": "կարգաբերման փայտ",
  "item.minecraft.music_disc_13": "ձայնասկավառակ□c418 - 13",
  "item.minecraft.music_disc_cat": "ձայնասկավառակ□c418 - cat",
  "item.minecraft.music_disc_blocks": "ձայնասկավառակ□c418 - blocks",
  "item.minecraft.music_disc_chirp": "ձայնասկավառակ□c418 - chirp",
  "item.minecraft.music_disc_far": "ձայնասկավառակ□c418 - far",
  "item.minecraft.music_disc_mall": "ձայնասկավառակ□c418 - mall",
  "item.minecraft.music_disc_mellohi": "ձայնասկավառակ□c418 - mellohi",
  "item.minecraft.music_disc_stal": "ձայնասկավառակ□c418 - stal",
  "item.minecraft.music_disc_strad": "ձայնասկավառակ□c418 - strad",
  "item.minecraft.music_disc_ward": "ձայնասկավառակ□c418 - ward",
  "item.minecraft.music_disc_11": "ձայնասկավառակ□c418 - 11",
  "item.minecraft.music_disc_wait": "ձայնասկավառակ□c418 - wait",
  "item.minecraft.music_disc_pigstep": "ձայնասկավառակ□լենա ռեյն - pigstep",
  "item.minecraft.trident": "եռաժանի□□հիմնական ձեռքում՝□+8 հարվածի ուժը□-2.9 հարձակման արագությունը",
  "item.minecraft.phantom_membrane": "ֆանտոմի թաղանթ",
  "item.minecraft.nautilus_shell": "նաուտիլուսի խխունջ",
  "item.minecraft.heart_of_the_sea": "ծովի սիրտ",
  "item.minecraft.crossbow": "խաչաղեղ",
  "item.minecraft.suspicious_stew": "կասկածելի շոգեխաշել",
  "block.minecraft.loom": "տեքստիլ հաստոց",
  "item.minecraft.flower_banner_pattern": "դրոշի նախշ□ծաղիկ",
  "item.minecraft.creeper_banner_pattern": "դրոշի նախշ□քրիփեր",
  "item.minecraft.skull_banner_pattern": "դրոշի նախշ□գանգ",
  "item.minecraft.mojang_banner_pattern": "դրոշի նախշ□բան",
  "item.minecraft.globe_banner_pattern": "դրոշի նախշ□երկրագունդ",
  "item.minecraft.piglin_banner_pattern": "դրոշի նմուշ□մռութ",
  "block.minecraft.composter": "հողի մնացորդների տարա",
  "block.minecraft.barrel": "տակառ",
  "block.minecraft.smoker": "ծխանոց",
  "block.minecraft.blast_furnace": "հալման վառարան",
  "block.minecraft.cartography_table": "քարտեզագրի սեղան",
  "block.minecraft.fletching_table": "նետաձգի սեղան",
  "block.minecraft.grindstone": "սրոց",
  "block.minecraft.lectern": "ամբիոն",
  "block.minecraft.smithing_table": "դարբնի սեղան",
  "block.minecraft.stonecutter": "քարհատիչ",
  "block.minecraft.bell": "զանգ",
  "block.minecraft.lantern": "լապտեր",
  "block.minecraft.soul_lantern": "հոգու լապտեր",
  "item.minecraft.sweet_berries": "քաղցր հատապտուղներ",
  "block.minecraft.campfire": "խարույկ",
  "block.minecraft.soul_campfire": "հոգու խարույկ",
  "block.minecraft.shroomlight": "սնկալույս",
  "item.minecraft.honeycomb": "մեղրամոմ",
  "block.minecraft.bee_nest": "փեթակ",
  "block.minecraft.beehive": "մեղվաբույն",
  "item.minecraft.honey_bottle": "մեղրով շիշ",
  "block.minecraft.honey_block": "մեղրի բլոկ",
  "block.minecraft.honeycomb_block": "մեղրամոմի բլոկ",
  "block.minecraft.lodestone": "մագնիս",
  "block.minecraft.netherite_block": "նեզերիտի բլոկ",
  "block.minecraft.ancient_debris": "հնագույն ավերակներ",
  "block.minecraft.target": "թիրախ",
  "block.minecraft.crying_obsidian": "լացող օբսիդիան",
  "block.minecraft.blackstone": "սեւքար",
  "block.minecraft.blackstone_slab": "սեւքարե սալիկ",
  "block.minecraft.blackstone_stairs": "սևքարե աստիճաններ",
  "block.minecraft.gilded_blackstone": "ոսկիացված սևքար",
  "block.minecraft.polished_blackstone": "հարթեցված սևքար",
  "block.minecraft.polished_blackstone_slab": "հարթեցված սևքարե սալիկ",
  "block.minecraft.polished_blackstone_stairs": "հարթեցված սևքարե աստիճաններ",
  "block.minecraft.chiseled_polished_blackstone": "փորագրված հարթեցված սևքար",
  "block.minecraft.polished_blackstone_bricks": "հարթեցված սևքարե աղյուսներ",
  "block.minecraft.polished_blackstone_brick_slab": "հարթեցված սևքարե աղյուսե սալիկ",
  "block.minecraft.polished_blackstone_brick_stairs": "հարթեցված սևքարե աղյուսե աստիճաններ",
  "block.minecraft.cracked_polished_blackstone_bricks": "ճաքած հարթեցված սևքարե աղյուս",
  "block.minecraft.respawn_anchor": "վերածնման խարիսխ",
}
export const hy_am = items; 
